import { render } from "./History.vue?vue&type=template&id=6b9c62c5&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=6b9c62c5&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9c62c5"]])

export default __exports__